import MetaWrapper from '@components/Meta/MetaWrapper'
import React, { useEffect } from 'react'
import Page from './Page'
import { Redirect, useParams } from 'react-router-dom'
import { useWholesaleProductQuery } from '@graphql/queries/__generated__/wholesale.generated'
import useGlobalLoader from '../../../hooks/useGlobalLoader'
import { PAGE_404_URL } from '../../../urls'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { useTranslation } from 'react-i18next'

const View: React.FC = () => {
  const { t } = useTranslation()
  const { slug } = useParams<{ slug: string }>()
  const { setLoading } = useGlobalLoader()
  const meQueryResult = useMeQuery({ fetchPolicy: 'cache-first', nextFetchPolicy: 'cache-first' })
  const { data, loading } = useWholesaleProductQuery({
    variables: { slug },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  useEffect(() => {
    setLoading(loading && !data)
  }, [loading, data])

  return (
    <MetaWrapper
      titleDetails={t('metaTitle.wholesaleProduct', {
        defaultValue: 'Wholesale {{productName}}',
        productName: data?.wholesaleProduct?.name || '',
      })}
    >
      {!loading && !data?.wholesaleProduct && <Redirect to={PAGE_404_URL} />}
      <Page product={data?.wholesaleProduct} user={meQueryResult.data?.me} />
    </MetaWrapper>
  )
}

export default View
